module.exports = {"login":"/login","home":"/","account":"/account","passwordForget":"/pw-forget","allWebProperties":"/web-properties"}


//////////////////
// WEBPACK FOOTER
// ./src/routes.json
// module id = 69
// module chunks = 0